// extracted by mini-css-extract-plugin
export default {"loading":"A1_ZEedANalOCf4zw5pq-style-loading"};